import React from 'react'
import UpdateItem22Mai2024 from './UpdateItem22Mai2024'
import UpdateItem18Jul2023 from './UpdateItem18Jul2023'
import UpdateItem21Feb2023 from './UpdateItem21Feb2023'
import Translation from '../Translation/cont/Translation'
import { buildChangelogText } from './changelogEntries'

const POPUP_COMPONENTS = {
    'newsletter-2024':   UpdateItem22Mai2024,
    'slider-2023':       UpdateItem18Jul2023,
    'settings-feb-2023': UpdateItem21Feb2023,
}

const TAG_TRANSLATION_IDS = {
    'Feature':    'dashboard_changelog_tag_feature',
    'Bugfix':     'dashboard_changelog_tag_bugfix',
    'New Module': 'dashboard_changelog_tag_new_module',
}

const PREVIEW_MAX = 320

function stripHtml(html) {
    return html
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<[^>]*>/g, '')
        .replace(/\s+/g, ' ')
        .trim()
}

function truncateText(text, max) {
    if (text.length <= max) return { text, truncated: false }
    const cut = text.lastIndexOf(' ', max)
    return { text: text.slice(0, cut > 0 ? cut : max) + '…', truncated: true }
}

function getPreview(html) {
    const greyMarker = "<span class='grey'>"
    const greyStart  = html.indexOf(greyMarker)

    const deHtml = greyStart === -1 ? html : html.slice(0, greyStart).trim()
    const enHtml = greyStart === -1 ? '' : html.slice(greyStart + greyMarker.length, html.lastIndexOf('</span>')).trim()

    const de = truncateText(stripHtml(deHtml), PREVIEW_MAX)
    const en = enHtml ? truncateText(stripHtml(enHtml), PREVIEW_MAX) : null

    const truncated = de.truncated || (en && en.truncated)
    const previewHtml = en
        ? `${de.text}<br/><span class='grey'>${en.text}</span>`
        : de.text

    return { html: previewHtml, truncated }
}

class DashboardChangelog extends React.Component {
    constructor(props) {
        super(props)
        this.state = { showAll: false, popupEntry: null, activeFilter: null }
    }

    render() {
        const { entries, readVersions, onMarkRead, onMarkAllRead, cinemaProviderArr } = this.props
        const { showAll, popupEntry, activeFilter } = this.state

        const filteredEntries = activeFilter
            ? entries.filter(e => e.tags && e.tags.includes(activeFilter))
            : entries
        const unreadCount    = filteredEntries.filter(e => !readVersions.includes(e.version)).length
        const allVersions    = filteredEntries.map(e => e.version)
        const visibleEntries = showAll ? filteredEntries : filteredEntries.slice(0, 10)

        return (
            <div className="db-changelog">
                <div className="db-cl-head">
                    <div className="db-cl-title-row">
                        <span className="db-cl-title title-large"><Translation id="dashboard_changelog_title">Updates</Translation></span>
                        {unreadCount > 0 && (
                            <span className="db-cl-badge">{unreadCount}</span>
                        )}
                        <div className="db-cl-filters">
                            {['Feature', 'Bugfix', 'New Module'].map(f => (
                                <span
                                    key={f}
                                    className={`db-cl-filter text-xsmall-light${f === 'Bugfix' ? ' db-cl-filter--bugfix' : f === 'New Module' ? ' db-cl-filter--new-module' : ''}${activeFilter === f ? ' db-cl-filter--active' : ''}`}
                                    onClick={() => this.setState({ activeFilter: activeFilter === f ? null : f, showAll: false })}
                                >
                                    <Translation id={TAG_TRANSLATION_IDS[f]}>{f}</Translation>
                                </span>
                            ))}
                        </div>
                    </div>
                    {unreadCount > 0 && (
                        <span
                            className="db-cl-mark-all text-light"
                            onClick={() => onMarkAllRead(allVersions)}
                        >
                            <Translation id="dashboard_changelog_mark_all_read">Alle als gelesen markieren</Translation>
                        </span>
                    )}
                </div>

                <div className="db-cl-scroll">
                    <div className="db-cl-timeline">
                        {visibleEntries.map((entry, idx) => {
                            const isUnread              = !readVersions.includes(entry.version)
                            const isLast                = idx === visibleEntries.length - 1
                            const { html: previewHtml, truncated } = getPreview(buildChangelogText(entry, cinemaProviderArr))
                            const hasMore               = entry.componentKey || truncated

                            return (
                                <div
                                    key={entry.id}
                                    className={`db-cl-entry${isUnread ? ' db-cl-entry--unread' : ''}`}
                                >
                                    <div className={`db-cl-tl${!isLast ? ' db-cl-tl--line' : ''}`}>
                                        <div className="db-cl-dot" />
                                    </div>
                                    <div className="db-cl-content">
                                        <div className="db-cl-meta">
                                            <span className="db-cl-ver title-large-regular">{entry.version}</span>
                                            <span className="db-cl-date title-large-regular">{entry.date}</span>
                                            {entry.tags && entry.tags.map(tag => (
                                                <span key={tag} className={`db-tag db-tag--${tag.toLowerCase().replace(/\s+/g, '-')} text-xsmall-light`}>
                                                    <Translation id={TAG_TRANSLATION_IDS[tag]}>{tag}</Translation>
                                                </span>
                                            ))}
                                        </div>
                                        <div
                                            className="db-cl-text text-light"
                                            dangerouslySetInnerHTML={{ __html: previewHtml }}
                                        />
                                        {(hasMore || isUnread) && (
                                            <div className="db-cl-actions">
                                                {hasMore && (
                                                    <span
                                                        className="db-cl-mehr text-light"
                                                        onClick={() => {
                                                            this.setState({ popupEntry: entry })
                                                            if (isUnread) onMarkRead(entry.version)
                                                        }}
                                                    >
                                                        <Translation id="dashboard_changelog_read_more">Mehr lesen →</Translation>
                                                    </span>
                                                )}
                                                {isUnread && (
                                                    <span
                                                        className="db-cl-read text-light"
                                                        onClick={() => onMarkRead(entry.version)}
                                                    >
                                                        <Translation id="dashboard_changelog_mark_read">Als gelesen markieren</Translation>
                                                    </span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    {!showAll && filteredEntries.length > 10 && (
                        <div className="db-cl-footer">
                            <span className="db-cl-more text-light" onClick={() => this.setState({ showAll: true })}>
                                + <Translation id="dashboard_changelog_show_older" after={` (${filteredEntries.length - 10})`}>Ältere Updates anzeigen</Translation>
                            </span>
                        </div>
                    )}
                </div>

                {popupEntry && (
                    <div className="db-cl-popup" onClick={() => this.setState({ popupEntry: null })}>
                        <div className="db-cl-popup-box" onClick={e => e.stopPropagation()}>
                            <div className="db-cl-popup-head">
                                <div className="db-cl-meta">
                                    <span className="db-cl-ver title-large-regular">{popupEntry.version}</span>
                                    <span className="db-cl-date title-large-regular">{popupEntry.date}</span>
                                    {popupEntry.tags && popupEntry.tags.map(tag => (
                                        <span key={tag} className={`db-tag db-tag--${tag.toLowerCase().replace(/\s+/g, '-')} text-xsmall-light`}>
                                            <Translation id={TAG_TRANSLATION_IDS[tag]}>{tag}</Translation>
                                        </span>
                                    ))}
                                </div>
                                <span className="db-cl-popup-close" onClick={() => this.setState({ popupEntry: null })}>✕</span>
                            </div>
                            <div className="db-cl-popup-body">
                                {popupEntry.componentKey
                                    ? React.createElement(POPUP_COMPONENTS[popupEntry.componentKey], { lastUpdate: true, date: '' })
                                    : <div className="db-cl-text text-light" dangerouslySetInnerHTML={{ __html: buildChangelogText(popupEntry, cinemaProviderArr) }} />
                                }
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default DashboardChangelog
